import { useMutation } from '@tanstack/react-query'
import {
  exportSpendReport,
  ExportTransactionsParams,
} from '@/queries/transactions/queries.ts'

type UseExportSpendReportOptions = {
  onSuccess?: (blob: Blob) => void
  onError?: (error: Error) => void
}

export const useExportSpendReport = (options?: UseExportSpendReportOptions) => {
  return useMutation({
    mutationFn: (params: ExportTransactionsParams) => exportSpendReport(params),
    onSuccess: (blob) => {
      options?.onSuccess?.(blob)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
